// services/segmentacao.js
import axiosInstance from './axiosInstance';

const SEGMENTACAO_API_URL = '/segmentacao';

const segmentacaoService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${SEGMENTACAO_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async set(categoryData) {
    try {
      const response = await axiosInstance.get(`${SEGMENTACAO_API_URL}/set.php`, {
        params: categoryData
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar segmentacao:', error);
      throw error;
    }
  },

  async unset(idempresa, idsegmentacao) {
    try {
      const response = await axiosInstance.get(`${SEGMENTACAO_API_URL}/unset.php?idempresa=${idempresa}&idsegmentacao=${idsegmentacao}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export default segmentacaoService;
